import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { editTankNameDetails } from "../../actions/area";
import Spinner from "../layout/Spinner";

const EditTankNameDetails = ({
  setShowUpdateModal,
  savedMessage,
  auth: { isAuthenticated, user, users, loading },
  tankNames,
  editTankNameDetails,
}) => {
  //formData
  const [formData, setFormData] = useState({
    tankName: tankNames && tankNames.tankName ? tankNames.tankName : "",

    isSubmitted: false,
  });
  const { tankName } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onUpdate = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: tankNames ? tankNames._id : "",
      tankName: tankName,
      tankNameEnteredById: user._id,
      tankNameEnteredByName: user.userName,
      institutionId: user.institutionId,
    };

    editTankNameDetails(finalData);
    setShowUpdateModal(false);
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onUpdate(e)}>
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Tank Name* :</label>
              <input
                type="text"
                name="tankName"
                value={tankName}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
          </div>

          <div className="col-md-10 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Submit"
                value="Update"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

EditTankNameDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  editTankNameDetails: PropTypes.func.isRequired,
  savedMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  savedMessage: state.auth.savedMessage,
});

export default connect(mapStateToProps, {
  editTankNameDetails,
})(EditTankNameDetails);
